import { render, staticRenderFns } from "./EdicaoMassaDlg.vue?vue&type=template&id=7bcc6be2"
import script from "./EdicaoMassaDlg.vue?vue&type=script&lang=js"
export * from "./EdicaoMassaDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports